import { getJsonApiDataById } from "../jsonapi_helpers";
import { BASE_URL } from "../../config";

export const mapImageDatum = (image, included, addBaseUrl = false) => {
  if (!(image && image.data && image.data.id)) return;
  const imageData = getJsonApiDataById(image.data.id, included);
  if (!imageData) return;
  const { fid, uri, field_image_alt_text } = imageData.attributes;

  // Get the URL - handle both old structure and new base64 data
  let imageUrl = uri?.url || "";

  // If it's a base64 data URL or absolute URL, use it as-is
  if (imageUrl.startsWith("data:") || imageUrl.startsWith("http")) {
    return {
      fid,
      uuid: imageData.id,
      url: imageUrl,
      alt: field_image_alt_text,
    };
  }

  // Otherwise, it's a relative URL that might need BASE_URL prepended
  return {
    fid,
    uuid: imageData.id,
    url: addBaseUrl && imageUrl ? BASE_URL + imageUrl : imageUrl,
    alt: field_image_alt_text,
  };
};
